import React from 'react'
import HeroBanner from "../../Assets/Images/General/banner_img.png"
import { BusinessOutlined, ChevronRight } from '@mui/icons-material'
function Hero() {
    return (

        <section className="hero">
            <div className="container">
                <div className="hero-content">
                    <p className="hero-subtitle">
                        <BusinessOutlined />

                        <span>DEEPBLUE - Elevating your business to the world standard</span>
                    </p>

                    <h2 className="h1 hero-title">Bringing Companies and Customers together, anywhere - </h2>

                    <p className="hero-text">
                        A CRM Platform with powerfull features tailored towards <strong>Increasing</strong> your business <strong>Revenue and Sales</strong> with enterprise-grade link built to acquire and engage customers.
                    </p>
                    <div className="flex gap-3">
                        <button className="btn">Make An Enquiry</button>
                        <button className="btn flex btn-outline ">Get Started <span><ChevronRight /></span></button>

                    </div>
                </div>

                <figure className="hero-banner">
                    <img
                        src={HeroBanner}
                        alt="DEEPBLUE Banner"
                        className="w-100"
                    />
                </figure>
            </div>
        </section>

    )
}

export default Hero